import React from 'react';
import TriggerActionTypeSelect from './TriggerActionTypeSelect';
import SmartAlertLineItem from 'components/triggers/SmartAlertLineItem';
import UnsavedTriggerActions from 'actions/triggers/UnsavedTriggerActions';
import SmartAlertTrendDisplay from 'components/triggers/trigger-actions/SmartAlertTrendDisplay';

export default class SmartAlertTypeConfig extends React.PureComponent {
  componentDidMount() {
    const {trend, actionType} = this.props;

    // If theres already a trend saved set that as our action type
    if (trend) {
      return UnsavedTriggerActions.setActionType.defer('trend');
    }

    // If we don't have an action type set already from rule creation
    // then theres no trend, it must be an event.
    if (!actionType) {
      return UnsavedTriggerActions.setActionType.defer('event');
    }
  }

  render() {
    const {rule, trend, actionType, antiRules} = this.props;

    if (actionType === 'trend') {
      return (
        <SmartAlertLineItem label="Over this period">
          <SmartAlertTrendDisplay startInEditMode rule={rule} antiRules={antiRules} trend={trend} />
        </SmartAlertLineItem>
      );
    }

    if (!actionType) {
      return (
        <SmartAlertLineItem label="">
          <TriggerActionTypeSelect selectType={UnsavedTriggerActions.setActionType} />
        </SmartAlertLineItem>
      );
    }

    return null;
  }
}
